// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeReactionSetBody = {
  messageId: string;
  emoji?: string | null;
};

export type typeReactionSetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { emoji?: string | null };
};

export type typeReactionSetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeReactionSetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeReactionSetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaReactionSetBody = {
  type: "object",
  properties: {
    messageId: { type: "string", maxLength: 3000, minLength: 1 },
    emoji: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["messageId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createReactionSet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaReactionSetBody);
  }

  return async function postReactionSet(
    payload: typeReactionSetBody,
  ): Promise<typeReactionSetOutput200 | typeReactionSetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postReactionSet" failed before calling the network. #c67ce1468b70`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#c67ce1468b70" },
        },
        data: null,
      } as typeReactionSetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/reaction/set`,
      httpMethod: "POST",
      options,
    })) as typeReactionSetOutput200 | typeReactionSetOutput400;
  };
}
